import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { formatPrice } from "../../Helpers/BaseHelper";
import { useDispatch, useSelector } from "react-redux";
import { fetchFeedbackByTourId } from "@/redux/slices/feedbackSlice";
const ReviewOrderDetail = ({
  selectedTour,
  startDate,
  endDate,
  quantity,
  discount,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { feedbacks, averageRating } = useSelector((state) => state.feedback);
  useEffect(() => {
    if (selectedTour) {
      dispatch(fetchFeedbackByTourId(selectedTour.tourId));
    }
  }, [dispatch, selectedTour]);
  return (
    <div className="card order-details">
      <div className="card-header">
        <div className="d-flex align-items-center justify-content-between header-content">
          <h5>Xem lại chi tiết thông tin tour</h5>
          <a
            href="#"
            className="rounded-circle p-2 btn btn-light d-flex align-items-center justify-content-center"
            onClick={(e) => {
              e.preventDefault();

              navigate(`/tour-detail/${selectedTour.tourId}`, {
                state: {
                  startDateOrder: startDate,
                  endDateOrder: endDate,
                  quantityOrder: quantity,
                },
              });
            }}
          >
            <span className="fs-16 d-flex align-items-center justify-content-center">
              <i className="isax isax-edit-2"></i>
            </span>
          </a>
        </div>
      </div>
      <div className="card-body">
        <div className="pb-3 border-bottom">
          <div className="mb-3 review-img">
            <img
              src={
                selectedTour?.tourDetails?.length > 0 &&
                selectedTour.tourDetails[0]?.tourImages?.length > 0
                  ? selectedTour.tourDetails[0].tourImages[0].imageUrl
                  : "https://via.placeholder.com/150"
              }
              alt="Img"
              className="img-fluid"
            />
          </div>
          <div className="d-flex align-items-center justify-content-between">
            <div>
              <h6 className="mb-2">{selectedTour.tourName}</h6>
              <p className="fs-14 ">
                <span className="badge badge-warning text-gray-9 fs-13 fw-medium me-2">
                  {averageRating || 5.0}
                </span>
                ({feedbacks.length} Đánh giá)
              </p>
            </div>
            <h6 className="fs-14 fw-normal text-gray-9">
              {(selectedTour.price * quantity).toLocaleString("vi-VN", {
                style: "currency",
                currency: "VND",
              })}
            </h6>
          </div>
        </div>
        <div className="mt-3 pb-3 border-bottom">
          <h6 className="text-primary mb-3">Thông tin đặt tour</h6>
          <div className="d-flex align-items-center details-info">
            <h6 className="fs-16">Ngày khởi hành</h6>
            <p className="fs-16">{startDate}</p>
          </div>
          <div className="d-flex align-items-center details-info">
            <h6 className="fs-16">Ngày kết thúc</h6>
            <p className="fs-16">{endDate}</p>
          </div>
          <div className="d-flex align-items-center  details-info">
            <h6 className="fs-16">Số lượng</h6>
            <p className="fs-16">{quantity} người</p>
          </div>
          <div className="d-flex align-items-center details-info">
            <h6 className="fs-16">Số ngày</h6>
            <p className="fs-16">{selectedTour.numberDay} Ngày, 1 đêm</p>
          </div>
        </div>
        <div className="mt-3 border-bottom">
          <h6 className="text-primary mb-3">Thông tin thanh toán</h6>
          <div className="d-flex align-items-center justify-content-between mb-3">
            <h6 className="fs-16">Tổng cộng</h6>
            <p className="fs-16">
              {" "}
              {formatPrice(selectedTour.price * quantity)}
            </p>
          </div>

          <div className="d-flex align-items-center justify-content-between mb-3">
            <h6 className="fs-16">
              Giảm giá{" "}
              <span className="text-gray-6">
                {" "}
                ({discount ? discount.discountPercentage : 0}%)
              </span>
            </h6>
            <p className="fs-16">
              -
              {discount
                ? formatPrice(
                    selectedTour.price *
                      quantity *
                      (discount.discountPercentage / 100)
                  )
                : formatPrice(0)}
            </p>
          </div>
        </div>
        <div className="mt-3">
          <div className="d-flex align-items-center justify-content-between">
            <h6>Số tiền phải trả</h6>
            <h6 className="text-primary">
              {discount
                ? formatPrice(
                    selectedTour.price *
                      quantity *
                      (1 - discount.discountPercentage / 100)
                  )
                : formatPrice(selectedTour.price * quantity)}
            </h6>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewOrderDetail;
